export enum MobilePlatform {
    IOS = 'IOS', ANDROID = 'ANDROID'
}

export function toMobilePlatform(value: string): MobilePlatform | undefined {
    const key = value.toUpperCase();
    return MobilePlatform[key as keyof typeof MobilePlatform];
}
